import React from "react";

// Bloque de una pantalla de captura: titulo, ayuda opcional y sus campos.
//   <Seccion titulo="Datos del vino" icono="fas fa-wine-bottle" ayuda="...">
//     <Row>...</Row>
//   </Seccion>
function Seccion({ titulo, icono, ayuda, children }) {
  return (
    <section className="form-seccion">
      <header>
        {icono ? <span className="form-seccion-icono"><i className={icono} /></span> : null}
        <div>
          <h4>{titulo}</h4>
          {ayuda ? <p>{ayuda}</p> : null}
        </div>
      </header>
      {children}
    </section>
  );
}

// Resumen de importes de una captura. items: [{ t: "IVA", v: 100 }, { t: "Botellas", v: 12, n: true }]
export function Totales({ items }) {
  const dinero = (v) => new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(Number(v) || 0);
  return (
    <div className="form-totales">
      {items.map((i) => (
        <div key={i.t}>
          <span>{i.t}</span>
          <strong>{i.n ? new Intl.NumberFormat("en-US").format(Number(i.v) || 0) : dinero(i.v)}</strong>
        </div>
      ))}
    </div>
  );
}

export default Seccion;
